import Phaser from "phaser";

import { RewardVaultScene, type RewardVaultVisualState } from "./RewardVaultScene";

export type RewardVaultRuntime = {
  game: Phaser.Game;
  scene: RewardVaultScene;
  ready: Promise<void>;
  renderScale: number;
  resize(width: number, height: number): void;
  destroy(): void;
};

const MAX_RENDER_SCALE = 2;

function getRenderScale(): number {
  return Math.min(MAX_RENDER_SCALE, Math.max(1, window.devicePixelRatio || 1));
}

export function createRewardVaultGame(
  parent: HTMLElement,
  visualState: RewardVaultVisualState,
): RewardVaultRuntime {
  const renderScale = getRenderScale();
  const logicalWidth = parent.clientWidth || 360;
  const logicalHeight = parent.clientHeight || 230;
  let resolveReady: () => void = () => undefined;
  const ready = new Promise<void>((resolve) => {
    resolveReady = resolve;
  });
  const scene = new RewardVaultScene({ onReady: resolveReady }, visualState, renderScale);
  const game = new Phaser.Game({
    type: Phaser.CANVAS,
    parent,
    width: Math.round(logicalWidth * renderScale),
    height: Math.round(logicalHeight * renderScale),
    transparent: true,
    antialias: true,
    render: { antialias: true, pixelArt: false, roundPixels: false },
    scale: { mode: Phaser.Scale.NONE, autoCenter: Phaser.Scale.NO_CENTER },
    scene: [scene],
    banner: false,
  });
  const canvas = parent.querySelector("canvas");
  if (canvas !== null) {
    canvas.style.pointerEvents = "none";
    canvas.setAttribute("aria-hidden", "true");
  }
  return {
    game,
    scene,
    ready,
    renderScale,
    resize(width: number, height: number): void {
      game.scale.resize(Math.round(width * renderScale), Math.round(height * renderScale));
    },
    destroy(): void {
      game.destroy(true);
    },
  };
}
